export interface UnitLabelFields {
  name: string;
  neighborhood?: string | null;
  city?: string | null;
  state?: string | null;
}

/** Story 69.7: no card cabe pouco. Com nomes repetidos, o que diferencia é o lugar. */
export function formatUnitShortLabel(unit: UnitLabelFields, units: UnitLabelFields[]): string {
  const repeated = units.filter((other) => other.name === unit.name).length > 1;
  const place = [unit.city, unit.state].filter(Boolean).join('/');
  return repeated && place ? place : unit.name;
}

/** Story 69.7: com 1 unidade o card não muda; com a unidade filtrada, só os sem unidade têm marca. */
export function agendaCardUnitLabel(
  location: (UnitLabelFields & { id: string }) | null | undefined,
  filteredUnitId: string | null,
  units: UnitLabelFields[],
): string | null {
  if (units.length < 2) return null;
  if (!location) return 'Sem unidade';
  if (location.id === filteredUnitId) return null;
  return formatUnitShortLabel(location, units);
}

export function formatUnitLabel({ name, neighborhood, city, state }: UnitLabelFields): string {
  const cityState = [city, state].filter(Boolean).join('/');
  const place = [neighborhood, cityState].filter(Boolean).join(' - ');
  return place ? `${name} — ${place}` : name;
}
